import apiService from '../api/api.service';
import {
  ReferralCampaign,
  ReferralCode,
  ReferralReward,
  ReferralHistory,
  CreateReferralCodeRequest,
  ReferralRewardInfo
} from '../../types/referral.types';

class ReferralService {
  private static instance: ReferralService;

  private constructor() {}

  public static getInstance(): ReferralService {
    if (!ReferralService.instance) {
      ReferralService.instance = new ReferralService();
    }
    return ReferralService.instance;
  }

  /**
   * Şirketin katılabileceği aktif kampanyaları getir
   */
  public async getCampaigns(): Promise<ReferralCampaign[]> {
    const response = await apiService.get<ReferralCampaign[]>('/referral/campaigns');
    return response;
  }

  /**
   * Yeni referans kodu oluştur
   */
  public async createCode(data: CreateReferralCodeRequest): Promise<ReferralCode> {
    const response = await apiService.post<ReferralCode>('/referral/codes', data);
    return response;
  }

  /**
   * Şirketin kazandığı ödülleri getir
   * @param status Ödül durumu (opsiyonel, default: 'EARNED')
   */
  public async getRewards(status?: 'EARNED' | 'USED' | 'CANCELLED'): Promise<ReferralReward[]> {
    const queryParam = status ? `?status=${status}` : '';
    const response = await apiService.get<ReferralReward[]>(`/referral/rewards${queryParam}`);
    return response;
  }

  /**
   * Şirketin referans geçmişini getir
   * v2.0: Artık ReferralHistoryV2[] döner (şirkete özel, çok kullanımlı kodlar)
   */
  public async getHistory(): Promise<any[]> {
    const response = await apiService.get<any[]>('/referral/history');
    return response;
  }

  /**
   * Referans kodunun ödül bilgisini getir (authentication gerektirmez - yeni şirket kayıt formu için)
   * @param code Referans kodu
   */
  public async getRewardInfo(code: string): Promise<ReferralRewardInfo | null> {
    try {
      // Bu endpoint authentication gerektirmediği için doğrudan fetch kullanıyoruz
      // Base URL'in sonundaki slash'ı temizle ve endpoint'in başındaki slash'ı ekle
      let baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:7575/api';
      baseUrl = baseUrl.replace(/\/$/, ''); // Sonundaki slash'ı kaldır
      const endpoint = '/referral/reward-info'; // Endpoint başında slash var
      const url = `${baseUrl}${endpoint}?code=${encodeURIComponent(code)}`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
      
      // API'den gelen yanıt formatı: { code: 200, data: { ... } }
      if (data.code === 200 && data.data) {
        // rewardValue string olarak gelebilir, number'a çevir
        return {
          rewardType: data.data.rewardType,
          rewardValue: typeof data.data.rewardValue === 'string' 
            ? parseFloat(data.data.rewardValue) 
            : data.data.rewardValue,
          description: data.data.description
        };
      }
      
      return null;
    } catch (error) {
      console.error('Referans kodu bilgisi alınırken hata:', error);
      return null;
    }
  }
}

export default ReferralService.getInstance();

